module.exports = __webpack_public_path__ + "img/1d3338b.png";